var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.921,
    height: 17.928,
    viewBox: "0 0 20.921 17.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#162d43;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.713,8.272a4.742,4.742,0,0,1,4.757,4.72,4.54,4.54,0,0,1-.341,1.727l2.778,2.755a11.161,11.161,0,0,0,3.263-4.482A11.267,11.267,0,0,0,8.917,6.573l2.054,2.04A4.7,4.7,0,0,1,12.713,8.272ZM3.2,5.7,5.373,7.852l.439.434A11.108,11.108,0,0,0,2.25,12.992a11.283,11.283,0,0,0,14.627,6.284l.4.4,2.787,2.755,1.209-1.2L4.407,4.5Zm5.257,5.215,1.475,1.461a2.674,2.674,0,0,0-.075.612,2.838,2.838,0,0,0,2.853,2.829,2.683,2.683,0,0,0,.616-.075L14.8,17.2a4.733,4.733,0,0,1-6.849-4.221A4.664,4.664,0,0,1,8.459,10.915Zm4.1-.733,3,2.974.019-.149a2.838,2.838,0,0,0-2.853-2.829Z",
    transform: "translate(-2.25 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon-password.0d7b4c91943b44c78f14249e59e9efda.svg";
export { ForwardRef as ReactComponent };